export function extractList(data: unknown): any[] {
  if (Array.isArray(data)) return data;
  const nested = (data as { data?: unknown } | null)?.data;
  return Array.isArray(nested) ? nested : [];
}
